'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Switch_module = require('../styles/Switch.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The Switch component is used to switch between two options and the result of the change is immediate
 *
 * @component
 * @example
 * ```jsx
 * <Switch>content</Switch>
 * ```
 */
const Switch = React__namespace.forwardRef((props, ref) => {
    const { name, value, checked, disabled, readOnly, className, children, onChange = reactUtils.noop, ...restProps } = props;
    const cx = reactUtils.useStyles(Switch_module.default);
    const classNames = cx(className, 'container', {
        checked,
        disabled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'read-only': readOnly,
    });
    const controlClassNames = cx('control', {
        checked,
        disabled,
    });
    const handlerClassNames = cx('handler', {
        checked,
        disabled,
    });
    // const handleClick = (event)
    return (React__namespace.createElement("label", { "data-qa": "Switch", className: classNames },
        React__namespace.createElement("input", { ref: ref, className: cx('input'), type: "checkbox", name: name, value: value, checked: checked, disabled: disabled, onChange: onChange, ...restProps }),
        React__namespace.createElement("div", { className: controlClassNames },
            React__namespace.createElement("div", { className: handlerClassNames })),
        children ? React__namespace.createElement("span", { className: cx('label') }, children) : null));
});
Switch.defaultProps = {
    checked: false,
};
Switch.displayName = 'Switch';

exports.Switch = Switch;
//# sourceMappingURL=Switch.js.map
